import React, { useEffect, useState } from 'react'
// @ts-ignore
import Lottie from 'react-lottie-segments'

import styled from 'styled-components'

import animationData from 'assets/lottie/scrubber.lottie.json'

const StyledHandle = styled('div')<{ opacity: number; barWidth: number }>`
  bottom: 8px;
  margin-left: ${(props) => (props.barWidth === 4 ? -22 : -20)}px;
  opacity: ${(props) => props.opacity};
  position: relative;
  z-index: 5;
`

const FRAME_DATA = {
  ENTER: [0, 40],
  MOUSE_DOWN: [40, 79],
  MOUSE_UP: [79, 40],
}

const FRAME_DIRECTION = {
  FORWARD: 1,
  REVERSE: -1,
}

export const ScubberHandle: React.FC<{
  barWidth: number
  height: number
  isDragging: boolean
  width: number
}> = ({ barWidth, height, isDragging, width }) => {
  const [segmentOptions, setSegmentOptions] = useState({
    direction: FRAME_DIRECTION.FORWARD,
    options: {
      forceFlag: false,
      segments: FRAME_DATA.ENTER,
    },
    speed: 1,
  })
  const [opacity, setOpacity] = useState(0)

  const handleMouseDown = () => {
    setSegmentOptions({
      direction: FRAME_DIRECTION.FORWARD,
      options: {
        segments: FRAME_DATA.MOUSE_DOWN,
        forceFlag: true,
      },
      speed: 1,
    })
  }

  const handleMouseUp = () => {
    setTimeout(() => {
      setSegmentOptions({
        direction: FRAME_DIRECTION.REVERSE,
        options: {
          segments: FRAME_DATA.MOUSE_UP,
          forceFlag: true,
        },
        speed: 1.5,
      })
    }, 0)
  }

  const domLoaded = () => {
    setTimeout(() => {
      setOpacity(1)
      setSegmentOptions({
        direction: FRAME_DIRECTION.FORWARD,
        options: {
          segments: FRAME_DATA.ENTER,
          forceFlag: true,
        },
        speed: 1,
      })
    }, 250)
  }

  useEffect(() => {
    if (
      !isDragging &&
      segmentOptions.options.segments === FRAME_DATA.MOUSE_DOWN
    ) {
      handleMouseUp()
    }
  }, [isDragging, segmentOptions.options.segments])

  return (
    <StyledHandle
      barWidth={barWidth}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onTouchEnd={handleMouseUp}
      onTouchStart={handleMouseDown}
      opacity={opacity}
    >
      <Lottie
        direction={segmentOptions.direction}
        eventListeners={[
          {
            callback: domLoaded,
            eventName: 'DOMLoaded',
          },
        ]}
        height={height}
        isPaused={false}
        isStopped={false}
        options={{
          animationData,
          loop: false,
        }}
        playSegments={segmentOptions.options}
        segments={FRAME_DATA}
        speed={segmentOptions.speed}
        width={width}
      />
    </StyledHandle>
  )
}
